/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'city-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M24.5 24H23v-7.75a.498.498 0 0 0-.18-.384l-4.5-3.75a.5.5 0 0 0-.64 0l-4.5 3.75a.499.499 0 0 0-.18.384V24h-1v-7.75a1.5 1.5 0 0 1 .54-1.152L17 11.38V.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5V24H9V3H7.5A1.5 1.5 0 0 0 6 4.5V24H3v-4a.456.456 0 0 0-.012-.06A2.914 2.914 0 0 0 5 17a2.784 2.784 0 0 0-2.5-3A2.784 2.784 0 0 0 0 17a2.914 2.914 0 0 0 2.012 2.94A.456.456 0 0 0 2 20v4H.5a.5.5 0 0 0 0 1h24a.5.5 0 0 0 0-1zm-12-20h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zM20 24h-4v-5h4z"/><path pid="1" d="M21 13.047V4.5A1.5 1.5 0 0 0 19.5 3H18v8a1.498 1.498 0 0 1 .96.348z"/>'
  }
})
